import { MODULE_NAME } from "../helpers"

export const selectUser = state => state[MODULE_NAME].user
export const selectRoles = state => state[MODULE_NAME].roles
export const selectUserStatus = state => state[MODULE_NAME].userStatus
export const selectPermissions = state => state[MODULE_NAME].permissions
export const selectPermissionsStatus = state =>
  state[MODULE_NAME].permissionsStatus

// Создают селекторы проверки наличия конкретной роли / полномочия
export const hasRole = role => state => Boolean(selectRoles(state)[role])
export const hasPermission = permission => state =>
  Boolean(selectPermissions(state)[permission])
